import { TypeListFields } from 'contentful-types'
import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'

import List from './List'

const ContentfulList = withContentful<TypeListFields>(List)

export default ContentfulList
